<script>
import axios from 'axios';
import ContentTreeNode from './ContentTreeNode.vue';
export default {
  name: 'ContentTree', components: { ContentTreeNode },
  props: { courseId: [String, Number], academicYearId: [String, Number] },
  data: () => ({ groups: [], loading: true, error: '', request: null }),
  computed: { scope() { return { course_id: this.courseId || undefined, academic_year_id: this.academicYearId || undefined }; } },
  watch: { scope: { immediate: true, handler() { this.load(); } } },
  methods: {
    async load() {
      this.request?.abort();
      const request = new AbortController(); this.request = request;
      this.loading = true; this.error = '';
      try {
        const res = await axios.get('/web/content-tree', { params: this.scope, signal: request.signal });
        if (!request.signal.aborted) this.groups = res.data.data;
      } catch (e) {
        if (!request.signal.aborted) this.error = e.response?.data?.message || 'تعذر تحميل المحتوى. حاول مرة أخرى.';
      } finally { if (!request.signal.aborted) this.loading = false; }
    },
  },
  beforeUnmount() { this.request?.abort(); },
};
</script>
<template>
  <section class="content-tree" dir="rtl" aria-label="شجرة المحتوى">
    <p v-if="loading" role="status"><i class="pi pi-spin pi-spinner"></i> جاري تحميل المحتوى...</p>
    <div v-else-if="error" role="alert"><p>{{ error }}</p><button class="btn btn-outline-primary" @click="load">إعادة المحاولة</button></div>
    <template v-else>
      <section v-for="group in groups" :key="group.key" class="tree-owner">
        <h2>{{ group.title }}</h2>
        <ContentTreeNode v-for="node in group.children" :key="node.id" :node="node" />
      </section>
      <p v-if="!groups.length" role="status">لا يوجد محتوى متاح لحسابك حالياً.</p>
    </template>
  </section>
</template>
<style scoped>
.content-tree { --tree-accent: #5b5fef; --tree-surface: #fff; --tree-text: #172033; min-width: 0; width: 100%; }
.tree-owner { margin-bottom: 1.5rem; }
h2 { font-size: 1.3rem; margin-bottom: 1rem; }
</style>
